import { LiquidProduct } from '@/features/product/types'
import { Outfit } from '@/features/product/components/Outfit'
import { Image } from '@/types/LiquidObjects'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'

interface OutfitBuilderData {
  title: string
  description: string
  image: Image | null
  products: LiquidProduct[]
}

export const OutfitBuilder: ShopifySectionComponent<OutfitBuilderData> = ({
  data: { title, description, image, products } = {
    title: '',
    description: '',
    image: null,
    products: [],
  },
}) => {
  return (
    <Outfit
      outfit={{
        title,
        description,
        image,
        products,
      }}
    />
  )
}
